export const cookie = () => {
    let cookie = document.querySelector('.cookie-modal');
    if (!cookie) return;

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    function showCookie() {
        cookie.style.bottom = '63px';
    }

    function hideCookie() {
        cookie.style.bottom = '-100%';
    }

    function checkCookies() {
        let cookieBtnAccept = cookie.querySelector('.cookie-modal__btn');
        if (!cookieBtnAccept) return;

        cookieBtnAccept.addEventListener('click', function () {
            setCookie('cookies_policy_skk', 'true', 60);
            hideCookie();
        });

        if (getCookie('cookies_policy_skk')) return;

        const showOnThirdScreenHalf = () => {
            let triggerPoint = window.innerHeight;
            let viewportTop = window.scrollY;
            let viewportBottom = window.scrollY + window.innerHeight;
            let pageBottom = document.documentElement.scrollHeight;
            let isPageBottomReached = viewportBottom >= pageBottom - 2;

            if (viewportTop >= triggerPoint || isPageBottomReached) {
                showCookie();
                window.removeEventListener('scroll', showOnThirdScreenHalf);
                window.removeEventListener('resize', showOnThirdScreenHalf);
            }
        };

        window.addEventListener('scroll', showOnThirdScreenHalf, {passive: true});
        window.addEventListener('resize', showOnThirdScreenHalf);

        showOnThirdScreenHalf();
    }

    checkCookies();
}
